"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagsElement = void 0;

var TagsComponent_1 = require("../Component/TagsComponent");
/**
 * `TagsComponent` for the `RectRegion` class.
 */


var TagsElement = /*#__PURE__*/function (_TagsComponent_1$Tags) {
  _inherits(TagsElement, _TagsComponent_1$Tags);

  /**
   * Creates a new `TagsElement` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param tags - The `TagsDescriptor` object presenting colors and names for region tags.
   * @param styleId - The unique css style id for region.
   * @param styleSheet - The regerence to the stylesheet object for rules insection.
   * @param tagsUpdateOptions - The settings for redrawing tags.
   */
  function TagsElement(paper, paperRect, regionData, tags, styleId, styleSheet, tagsUpdateOptions) {
    var _this;

    _classCallCheck(this, TagsElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TagsElement).call(this, paper, paperRect, regionData, tags, styleId, styleSheet, tagsUpdateOptions));

    _this.buildOn(paper, tags);

    return _this;
  }
  /**
   * Redraws the componnent.
   */


  _createClass(TagsElement, [{
    key: "redraw",
    value: function redraw() {
      var _this2 = this;

      var rebuildTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // If there are tags assigned
      if (this.tags) {
        window.requestAnimationFrame(function () {
          if (_this2.tags.primary !== undefined && _this2.tags.primary !== null) {
            // Update primary tag rect
            _this2.primaryTagRect.attr({
              height: _this2.height,
              width: _this2.width,
              x: _this2.x,
              y: _this2.y
            }); // Update primary tag text


            if (rebuildTags) {
              _this2.primaryTagText.node.innerHTML = _this2.tags.primary !== null ? _this2.tags.primary.name : "";
              _this2.textBox = _this2.primaryTagText.getBBox();
            }

            var showTextLabel = _this2.textBox.width + 10 <= _this2.width && _this2.textBox.height <= _this2.height;

            if (showTextLabel) {
              _this2.primaryTagTextBG.attr({
                height: _this2.textBox.height + 5,
                width: _this2.textBox.width + 10,
                x: _this2.x + 1,
                y: _this2.y + 1
              });

              _this2.primaryTagText.attr({
                visibility: "visible",
                x: _this2.x + 5,
                y: _this2.y + _this2.textBox.height
              });
            } else {
              _this2.primaryTagTextBG.attr({
                height: Math.min(10, _this2.height),
                width: Math.min(10, _this2.width),
                x: _this2.x,
                y: _this2.y
              });

              _this2.primaryTagText.attr({
                visibility: "hidden",
                x: _this2.x + 5,
                y: _this2.y + _this2.textBox.height
              });
            }
          } else {
            _this2.primaryTagRect.attr({
              height: _this2.height,
              width: _this2.width,
              x: _this2.x,
              y: _this2.y
            });

            _this2.primaryTagTextBG.attr({
              height: 0,
              width: 0
            });

            _this2.primaryTagText.attr({
              visibility: "hidden",
              x: _this2.x + 5,
              y: _this2.y + _this2.textBox.height
            });
          } // Clear secondary tags -> redraw from scratch

          /*if (rebuildTags && this.secondaryTags) {
              this.secondaryTags.forEach((tag) => {
                  tag.remove();
              });
              this.secondaryTags = [];
          }*/
          // Recreate secondary tags


          if (_this2.tags.secondary && _this2.tags.secondary.length > 0) {
            // Update secondary tag text
            if (rebuildTags) {
              _this2.secondaryTagText.node.innerHTML = _this2.tags.secondary[0].name;
              _this2.secondaryTextBox = _this2.secondaryTagText.getBBox();
            }

            _this2.secondaryTagText.attr({
              visibility: "visible",
              x: _this2.x,
              y: _this2.y - 5
            });
          } else {
            _this2.secondaryTagText.attr({
              visibility: "hidden",
              x: _this2.x,
              y: _this2.y - 5
            });
          }
        });
      } else {
        window.requestAnimationFrame(function () {
          _this2.primaryTagRect.attr({
            height: _this2.height,
            width: _this2.width,
            x: _this2.x,
            y: _this2.y
          }); // Remove primary tag


          _this2.primaryTagText.node.innerHTML = "";

          _this2.primaryTagTextBG.attr({
            height: 0,
            width: 0
          }); // Clear secondary tags

          /*this.secondaryTags.forEach((tag) => {
              tag.remove();
          });
          this.secondaryTags = [];*/

        });
      }
    }
    /**
     * Inits style maps.
     */

  }, {
    key: "initStyleMaps",
    value: function initStyleMaps(tags) {
      var _this3 = this;

      if (tags !== null) {
        if (tags.primary !== null) {
          this.styleMap = [{
            rule: ".".concat(this.styleId, " .primaryTagRectStyle"),
            style: "fill: ".concat(tags.primary.colorShadow, ";\n                                stroke:").concat(tags.primary.colorAccent, ";")
          }, {
            rule: ".regionStyle.".concat(this.styleId, ":hover  .primaryTagRectStyle"),
            style: "fill: ".concat(tags.primary.colorHighlight, ";\n                                stroke: #fff;")
          }, {
            rule: ".regionStyle.selected.".concat(this.styleId, " .primaryTagRectStyle"),
            style: "fill: ".concat(tags.primary.colorHighlight, ";\n                                stroke:").concat(tags.primary.colorAccent, ";")
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .primaryTagTextBGStyle"),
            style: "fill:".concat(tags.primary.colorAccent, ";")
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle"),
            style: "stroke:".concat(tags.primary.colorDark, ";\n                                fill: ").concat(tags.primary.colorPure)
          }, {
            rule: ".regionStyle.".concat(this.styleId, ":hover .anchorStyle"),
            style: "stroke:#fff;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle.ghost"),
            style: "fill: var(--default-color-ghost);"
          }];
          this.styleLightMap = [{
            rule: ".".concat(this.styleId, " .primaryTagRectStyle"),
            style: "fill: ".concat(tags.primary.colorNoColor, ";\n                                stroke:").concat(tags.primary.colorAccent, ";\n                                stroke-width: 3px;")
          }, {
            rule: ".regionStyle.".concat(this.styleId, ":hover  .primaryTagRectStyle"),
            style: "fill: ".concat(tags.primary.colorHighlight, ";\n                                stroke: #fff;")
          }, {
            rule: ".regionStyle.selected.".concat(this.styleId, " .primaryTagRectStyle"),
            style: "fill: ".concat(tags.primary.colorNoColor, ";\n                                stroke:").concat(tags.primary.colorAccent, ";")
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .primaryTagTextBGStyle"),
            style: "fill:".concat(tags.primary.colorNoColor, ";")
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .primaryTagTextStyle"),
            style: "fill:".concat(tags.primary.colorAccent, ";")
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .secondaryTagTextStyle"),
            style: "fill:".concat(tags.primary.colorAccent, ";")
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .secondaryTagStyle"),
            style: "opacity:0.25;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle"),
            style: "stroke:".concat(tags.primary.colorDark, ";\n                                fill: ").concat(tags.primary.colorPure, ";\n                                stroke-width: 3px;")
          }, {
            rule: ".regionStyle.".concat(this.styleId, ":hover .anchorStyle"),
            style: "stroke:#fff;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle.ghost"),
            style: "fill: var(--default-color-ghost);"
          }];
        } else {
          this.styleMap = [];
          this.styleLightMap = [{
            rule: ".".concat(this.styleId, " .primaryTagRectStyle"),
            style: "fill: var(--default-color-transparent);\n                                stroke: var(--default-color-pure);\n                                stroke-width: 3px;"
          }, {
            rule: ".regionStyle.selected.".concat(this.styleId, " .primaryTagRectStyle"),
            style: "fill: var(--default-color-transparent);\n                                stroke: var(--default-color-pure);"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle"),
            style: "stroke-width: 3px;"
          }, {
            rule: ".regionStyle.".concat(this.styleId, " .anchorStyle.ghost"),
            style: "fill: var(--default-color-ghost);"
          }];
        }

        if (tags.secondary !== null && tags.secondary !== undefined) {
          tags.secondary.forEach(function (tag) {
            var rule = {
              rule: ".secondaryTagStyle.secondaryTag-".concat(tag.name),
              style: "fill: ".concat(tag.colorAccent, ";")
            };

            _this3.styleMap.push(rule);

            _this3.styleLightMap.push(rule);
          });
        }
      }
    }
    /**
     * Internal function to recreate tag labels.
     */

  }, {
    key: "rebuildTagLabels",
    value: function rebuildTagLabels() {
      this.redraw(true);
    }
    /**
     * Internal function to create tag labels
     * @param paper - The `Snap.Paper` object to draw on.
     * @param tags - The `TagsDescriptor` object defining tags.
     */

  }, {
    key: "buildOn",
    value: function buildOn(paper, tags) {
      this.primaryTagNode = paper.g();
      this.primaryTagRect = paper.rect(this.x, this.y, this.boundRect.width, this.boundRect.height);
      this.primaryTagRect.addClass("primaryTagRectStyle");
      this.primaryTagText = paper.text(this.x, this.y, "");
      this.primaryTagText.addClass("primaryTagTextStyle");
      this.textBox = this.primaryTagText.getBBox(); // bound to region???

      this.primaryTagTextBG = paper.rect(this.x, this.y, 0, 0);
      this.primaryTagTextBG.addClass("primaryTagTextBGStyle");
      this.primaryTagNode.add(this.primaryTagRect);
      this.primaryTagNode.add(this.primaryTagTextBG);
      this.primaryTagNode.add(this.primaryTagText); // secondary

      this.secondaryTagsNode = paper.g();
      this.secondaryTagText = paper.text(this.x, this.y, "");
      this.secondaryTagText.addClass("secondaryTagTextStyle");
      this.secondaryTextBox = this.secondaryTagText.getBBox();
      this.secondaryTagsNode.add(this.secondaryTagText);
      this.node.add(this.primaryTagNode);
      this.node.add(this.secondaryTagsNode);
      this.initStyleMaps(tags);
      this.updateTags(tags, this.tagsUpdateOptions);
    }
  }]);

  return TagsElement;
}(TagsComponent_1.TagsComponent);

exports.TagsElement = TagsElement;